/* Comprehensive country / region dataset for lead forms.
   Each entry: value = submitted country name, dial = intl calling code,
   alias = lowercase search aliases (cities, emirates, common market names). */

const RAW = [
  ["Afghanistan", "93"], ["Albania", "355"], ["Algeria", "213"], ["Andorra", "376"],
  ["Angola", "244"], ["Argentina", "54"], ["Armenia", "374"], ["Australia", "61"],
  ["Austria", "43"], ["Azerbaijan", "994"], ["Bahamas", "1"], ["Bahrain", "973"],
  ["Bangladesh", "880"], ["Barbados", "1"], ["Belarus", "375"], ["Belgium", "32"],
  ["Belize", "501"], ["Bolivia", "591"], ["Bosnia and Herzegovina", "387"],
  ["Botswana", "267"], ["Brazil", "55"], ["Brunei", "673"], ["Bulgaria", "359"],
  ["Cambodia", "855"], ["Cameroon", "237"], ["Canada", "1"], ["Chile", "56"],
  ["China", "86"], ["Colombia", "57"], ["Costa Rica", "506"], ["Croatia", "385"],
  ["Cyprus", "357"], ["Czech Republic", "420"], ["Denmark", "45"],
  ["Dominican Republic", "1"], ["Ecuador", "593"], ["Egypt", "20"],
  ["El Salvador", "503"], ["Estonia", "372"], ["Ethiopia", "251"], ["Fiji", "679"],
  ["Finland", "358"], ["France", "33"], ["Georgia", "995"], ["Germany", "49"],
  ["Ghana", "233"], ["Greece", "30"], ["Guatemala", "502"], ["Honduras", "504"],
  ["Hong Kong", "852"], ["Hungary", "36"], ["Iceland", "354"], ["India", "91"],
  ["Indonesia", "62"], ["Iraq", "964"], ["Ireland", "353"], ["Israel", "972"],
  ["Italy", "39"], ["Jamaica", "1"], ["Japan", "81"], ["Jordan", "962"],
  ["Kazakhstan", "7"], ["Kenya", "254"], ["Kuwait", "965"], ["Kyrgyzstan", "996"],
  ["Laos", "856"], ["Latvia", "371"], ["Lebanon", "961"], ["Libya", "218"],
  ["Lithuania", "370"], ["Luxembourg", "352"], ["Macau", "853"], ["Malaysia", "60"],
  ["Maldives", "960"], ["Malta", "356"], ["Mauritius", "230"], ["Mexico", "52"],
  ["Moldova", "373"], ["Monaco", "377"], ["Mongolia", "976"], ["Montenegro", "382"],
  ["Morocco", "212"], ["Myanmar", "95"], ["Nepal", "977"], ["Netherlands", "31"],
  ["New Zealand", "64"], ["Nicaragua", "505"], ["Nigeria", "234"],
  ["North Macedonia", "389"], ["Norway", "47"], ["Oman", "968"], ["Pakistan", "92"],
  ["Panama", "507"], ["Paraguay", "595"], ["Peru", "51"], ["Philippines", "63"],
  ["Poland", "48"], ["Portugal", "351"], ["Puerto Rico", "1"], ["Qatar", "974"],
  ["Romania", "40"], ["Rwanda", "250"], ["Saudi Arabia", "966"], ["Senegal", "221"],
  ["Serbia", "381"], ["Singapore", "65"], ["Slovakia", "421"], ["Slovenia", "386"],
  ["South Africa", "27"], ["South Korea", "82"], ["Spain", "34"], ["Sri Lanka", "94"],
  ["Sweden", "46"], ["Switzerland", "41"], ["Taiwan", "886"], ["Tanzania", "255"],
  ["Thailand", "66"], ["Trinidad and Tobago", "1"], ["Tunisia", "216"],
  ["Turkey", "90"], ["Uganda", "256"], ["Ukraine", "380"],
  ["United Arab Emirates", "971"], ["United Kingdom", "44"], ["United States", "1"],
  ["Uruguay", "598"], ["Uzbekistan", "998"], ["Venezuela", "58"], ["Vietnam", "84"],
  ["Zambia", "260"], ["Zimbabwe", "263"],
];

const ALIASES = {
  "United Arab Emirates": ["uae", "dubai", "abu dhabi", "sharjah", "emirates", "ajman", "ras al khaimah"],
  "United States": ["usa", "us", "america", "united states of america", "new york", "california", "los angeles", "san francisco", "chicago", "texas"],
  "United Kingdom": ["uk", "england", "britain", "great britain", "london", "scotland", "wales", "manchester"],
  Canada: ["toronto", "vancouver", "montreal", "ontario"],
  India: ["mumbai", "delhi", "new delhi", "bangalore", "bengaluru", "chennai", "hyderabad", "pune", "kolkata", "gurgaon", "gurugram", "noida"],
  "Saudi Arabia": ["saudi", "ksa", "riyadh", "jeddah"],
  Qatar: ["doha"],
  Kuwait: ["kuwait city"],
  Bahrain: ["manama"],
  Oman: ["muscat"],
  Australia: ["sydney", "melbourne", "brisbane", "perth"],
  "New Zealand": ["auckland", "wellington"],
  Germany: ["berlin", "munich", "frankfurt", "hamburg"],
  France: ["paris", "lyon"],
  Spain: ["madrid", "barcelona"],
  Italy: ["rome", "milan"],
  Netherlands: ["amsterdam", "rotterdam", "holland"],
  Ireland: ["dublin"],
  Switzerland: ["zurich", "geneva"],
  Singapore: ["sg"],
  Malaysia: ["kuala lumpur", "kl"],
  Indonesia: ["jakarta", "bali"],
  Thailand: ["bangkok"],
  Philippines: ["manila"],
  Japan: ["tokyo", "osaka"],
  "South Korea": ["seoul", "korea"],
  China: ["beijing", "shanghai", "shenzhen"],
  "Hong Kong": ["hk"],
  Brazil: ["sao paulo", "rio de janeiro"],
  Mexico: ["mexico city"],
  "South Africa": ["johannesburg", "cape town"],
  Kenya: ["nairobi"],
  Nigeria: ["lagos", "abuja"],
  Egypt: ["cairo"],
  Turkey: ["istanbul", "ankara"],
};

export const COUNTRIES = [
  ...RAW.map(([name, dial]) => ({
    value: name,
    label: name,
    dial: `+${dial}`,
    alias: ALIASES[name] || [],
  })),
  { value: "Other", label: "Other", dial: "", alias: [] },
];

export const countryDial = (value) =>
  (COUNTRIES.find((c) => c.value === value) || {}).dial || "";
